import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST_DELETE_IN_EXECUTOR_LIST =
  'SEND_REQUEST_DELETE_IN_EXECUTOR_LIST';
const SEND_REQUEST_DELETE_IN_CUSTOMER_LIST =
  'SEND_REQUEST_DELETE_IN_CUSTOMER_LIST';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => _.get(state, reducerName);

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState()
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST_DELETE_IN_EXECUTOR_LIST):
        return setRequestStateInProgress(state);
      case createActionName(name, SEND_REQUEST_DELETE_IN_CUSTOMER_LIST):
        return setRequestStateInProgress(state);
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequestDeleteInExecutorList = (parentName, blockedUserId) => ({
  type: createActionName(parentName, SEND_REQUEST_DELETE_IN_EXECUTOR_LIST),
  payload: { blockedUserId }
});
export const sendRequestDeleteInCustomerList = (parentName, blockedUserId) => ({
  type: createActionName(parentName, SEND_REQUEST_DELETE_IN_CUSTOMER_LIST),
  payload: { blockedUserId }
});
// SELECTORS
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/reducers/static/forms/removeUserBlackListForm/reduce.js